import React,{useState,useEffect} from 'react'
import { Tooltip } from '@mui/material';
import {  ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../../components/button';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import SettingsMenu from '../../staticscreens/SettingsMenu';
import {AiOutlineEdit,AiOutlineDelete} from 'react-icons/ai'
import { Modal } from 'antd';
import moment from 'moment';
import { DeleteWatiService, GetWatiService, GetWelcomeMessageListService } from '../../../services/WatiService';
import { DatePicker } from 'antd';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '@material-ui/core';

function TemplateListWelcome() {


    const [data,setdata] = useState([])
    const [selecteddata,setselecteddata] = useState({})
    const [modal, setModal] = useState(false);
    const navigate = useNavigate()
    const [page,setpage] = useState(1)
    const [search, setsearch] = useState({ text: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false,status:'Pending' })
    
    const status = ['Pending', 'Delivered', 'Failed', 'Read']

  
    useEffect(()=>{
        getTemplateListWelcome()
    },[page,search?.status])

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -40%)',
        width: 300,
        bgcolor: 'white',
        boxShadow: 4,
        p: 2,
        border:'0px solid white'
      };
    

  
  async function getTemplateListWelcome(){
   const response = await GetWelcomeMessageListService(page,search?.from_date1,search?.to_date1,search?.status)
   setdata(response.data)
  }  

  async function deletewatMessage(){
    const response = await DeleteWatiService(selecteddata._id)
    if(response.status === 200){
        setModal(false)
        toast.success(response.data)
        getTemplateListWelcome()
    }
  }

  async function applyFilter() {
      setsearch({ ...search, activate: true })
      setpage(1)
      const response = await GetWatiService(1, search?.from_date1, search?.to_date1,search?.status)
      setdata(response?.data)
    }

  function downloadFailed(){

    const headers = ["S.No", "Full Name", "Mobile", "Status"];
   const rows = data?.datas.map((d, i) => [i + 1, d.customer?.name, d.customer?.mobile,d?.message_status]);

    const csv =
    headers.join(",") + "\n" +
    rows.map(r => r.join(",")).join("\n");

      const blob = new Blob([csv], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "custom.csv";
      a.click();

  }  

  return (
    <div className='md:h-screen pt-5 md:pt-0 md:max-h-screen box-border md:overflow-hidden'>
   
     <Modal
        keepMounted
        open={modal}
        onClose={()=>setModal(false)}
        width={300}
        footer={false}
        closable={false}
       
      >
        <div >
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Are you sure?</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>After deleting you cannot retrieve it back before deleting check once whether you have used it in some data</h6>
          <div className='flex justify-end mt-3 '>
            {/* <div className='mr-1 w-full'> */}
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={()=>setModal(false)} />
            {/* </div> */}
            <div  className='ml-2'>
            <ButtonFilledAutoWidth btnName={'Confirm'} onClick={()=>deletewatMessage()}  /> 
            </div>
          </div>
        </div>
      </Modal>
        
      <div className='block sm:flex'>
        <SettingsMenu />

        <div className='md:w-[88%] px-4'>
        <div >
        <div className='pt-5'>
        <div className="flex justify-between align-center items-center border-b pb-2 ">
        <span className="font-[800] text-[14px]">Welcome's Message List ({data?.pagination?.total})</span>
         <div className='flex md:hidden items-center text-[12px]'>
          <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>
          <div>
            <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
            <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
          </div>
        </div>

          <div className='flex flex-wrap items-center text-[12px]'>
          <div className='hidden md:flex items-center'>
          <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>
          <div>
            <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
            <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
          </div>
          </div>

          <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.from_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, from_date: v, from_date1: v1 }) }} />

          <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.to_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, to_date: v, to_date1: v1 }) }} />

          <div className='mr-2 flex mt-1 md:mt-0'>
            <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
            <h6 onClick={downloadFailed} className='bg-slate-100 ml-2 cursor-pointer border rounded font-[600] w-max border-slate-300 text-[12px] px-1 py-1 '>Download List</h6>

          </div>
        </div> 
        </div>
        </div>


          <div className='flex items-center border-b overflow-x-auto flex-nowrap'>
                {status?.map((s)=>(
                <h6 onClick={()=>{setsearch({...search,status:s});setpage(1)}} className={`font-[600] ${search?.status === s && 'bg-[#2a297e] text-white'} flex-shrink-0 text-center cursor-pointer py-1 w-auto px-2 text-[11px]`}>{s}</h6>
                ))}
            </div>

        {data?.datas?.length === 0 &&
        <div className='grid place-items-center mt-20  items-center justify-center'>
        <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' /> 
        <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
        <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data added based on your current page option please click on add the data button to see list here.</h6>
      </div>
       }


        {data?.datas?.length > 0 &&
        <div className='md:max-h-[85vh] md:overflow-hidden border-t border-l border-r mt-2'>
             {data?.datas?.length !== 0 &&
                   <>
                   {/* Desktop / tablet table */}
                   <div className='hidden md:block md:max-h-[85vh] md:overflow-auto'>
                   <div className='top-0 z-50 flex border-b w-full bg-white py-[-5px]  border-slate-200 relative'>
                      <h6 className='text-[12px] truncate min-w-0  w-[50px]  px-2 py-1 font-[400] border-r'>Sl No</h6>
                      <h6 className='text-[12px] truncate min-w-0 flex-1 px-2 py-1 font-[400] border-r capitalize'>Name</h6>
                      <h6 className='text-[12px] truncate min-w-0 flex-1 px-2 py-1 font-[400] border-r capitalize'>Phone</h6>
                      <h6 className='text-[12px] truncate min-w-0 flex-[2] px-2 py-1 font-[400] border-r capitalize'>Message</h6>
                      <h6 className='text-[12px] truncate min-w-0 flex-[3] px-2 py-1 font-[400] border-r capitalize'>Error</h6>
                      <h6 className='text-[12px] truncate min-w-0  flex-1  px-2 py-1 font-[400] border-r capitalize'>Created On </h6>
                   </div>


                   {data?.datas?.map((d,i)=>(
                   <div key={d?._id} className='flex  w-full border-b cursor-pointer z-0'  >
                      <h6   className='text-[11px]  min-w-0 w-[50px] text-center  px-2 py-1   border-r '>{i+1}</h6>
                      <h6   className='text-[11px]  min-w-0 flex-1  font-[600] px-2 py-1   border-r '>{d?.customer?.name}</h6>
                      <h6   className='text-[11px]  min-w-0 flex-1  px-2 py-1   border-r '>{d?.customer?.mobile}</h6>
                      <h6   className='text-[11px] break-all  min-w-0 flex-[2] font-[600] px-2 py-1   border-r '>{d?.customer?.message}</h6>
                      <h6   className='text-[11px] break-all  min-w-0 flex-[3] px-2 py-1   border-r '>{d?.errors?.map((e)=>(
                        <h6>{e}</h6>
                      ))}</h6>

                      <h6   className='text-[10px]  min-w-0 flex-1  px-2 py-1 truncate  border-r '>{moment(d?.createdAt).format('lll')}</h6>

                   </div>))}
                   </div>

                   {/* Mobile card list */}
                   <div className='md:hidden space-y-2'>
                     {data?.datas?.map((d,i)=>(
                       <div key={d?._id} className='border rounded-md p-3 bg-white'>
                         <h6 className='text-[13px] font-[700]'>{d?.customer?.name}</h6>
                         <h6 className='text-[11px] text-slate-600'>{d?.customer?.mobile}</h6>
                         {d?.customer?.message && <h6 className='text-[11px] font-[600] mt-2 break-all'>{d?.customer?.message}</h6>}
                         {d?.errors?.length > 0 && <div className='bg-red-50 rounded p-2 mt-2 text-[11px]'>{d?.errors?.map((e,ei)=>(<h6 key={ei}>{e}</h6>))}</div>}
                         <h6 className='text-[10px] text-slate-400 mt-2'>{moment(d?.createdAt).format('lll')}</h6>
                       </div>
                     ))}
                   </div>
                   </>}
        </div>}
          </div>
        </div>
      </div> 
    </div>
  )
}

export default TemplateListWelcome